import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { HttpResponsesHandlersFactory } from "@bbwt/modules/data-service";
import { PagedCrudService } from "@features/grid";
import { FormTagDTO } from "../dto/formTagDTO";
import { UserService } from "@main/users";

@Injectable()
export class FormioTagsService extends PagedCrudService<FormTagDTO>{
  url: string = "api/form-tags";
  entityTitle: string = "Form Tag"

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory, private userservice: UserService) {
    super(http, handlersFactory);
  }

  async getAll(): Promise<FormTagDTO[]> {
      return await this.handleRequest<FormTagDTO[]>(
          this.http.get<FormTagDTO[]>(`${this.url}/all`),
          this.handlersFactory.getDefault());
  }
}
